module.exports = __webpack_public_path__ + "img/aoxingou.57e3c4d0.png";